import { useCallback, useMemo, useState } from "react";
import then from "@insightfulscience/shared-utils/async/then";
import { Right, Left } from "@insightfulscience/shared-utils/either";
import useUnmounted from "./useUnmounted";

function useActionResult(formAction) {
	const unmounted = useUnmounted();
	const [either, setResult] = useState(Right());

	const updateResult = useCallback(
		res => {
			if (unmounted.current) return;
			setResult(res);
		},
		[setResult],
	);

	const action = useMemo(
		() => then(updateResult)(formAction),
		[formAction], // deps
	);

	const reset = useCallback(
		() => updateResult(Right()),
		[formAction], // deps
	);

	const error = Left.extract(either);
	const result = Right.extract(either);

	return [action, { error, result, reset }];
}

export default useActionResult;
